<template>
  <v-container class="no-margins goBackAtTop">
    <v-btn text @click="goBack()">
      <v-icon>$sl-arrow-left</v-icon>{{ goBackLabel }}
    </v-btn>
  </v-container> 
</template>

<script>
import { mapActions, mapGetters } from "vuex"
// @group Common
// Styled GoBackAtTop component
export default {
  name: 'GoBackAtTop',

  props: {
    // Where to go to
    to: {
      // Example: `{name: 'MyLovelyList'}` etc.
      type: Object,
      required: true
    },
    label: {
      // Example: `'Go Back'` etc.
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters('app', ['lastPath']),
    goBackLabel() {
      if (this.to && this.to.meta && this.to.meta.preferLastPath && this.lastPath && this.lastPath.meta && this.lastPath.meta.label) {
        return this.lastPath.meta.label
      } else {
        return this.label
      }
    }
  },

  methods: {
    goBack() {
      if (this.to && this.to.meta && this.to.meta.preferLastPath && this.lastPath) {
        this.$nextTick(()=>{
          this.$router.go(-1)
        })
      } else {
        this.$nextTick(()=>{
          this.$router.push(this.to)
        })
      }
    }
  },

}
</script>

<style lang="scss" scoped>

// .theme--light.v-btn--active.goBackAtTop::before {
//     opacity: 0.075;
// }
</style>